module.exports = __webpack_public_path__ + "static/AppleStoreIcon-bd31315c0e7d5b9be90f0097bfa8f1bf.svg";